import React, { useEffect, useRef } from "react";
import { PLATFORM_BRAND } from "./config";

const SCRIPT_ID = "tf-cert-script";
const FIELD = "xxTrustedFormCertUrl";
const CERT_RE = /^https:\/\/cert\.trustedform\.com\//;
// The SDK issues one certificate per page load (it removes its own script tag, so track it here).
let sdkLoadedAt = null;

// The Certify SDK writes the certificate into its own hidden field inside the form.
export function readTrustedFormCert() {
  const el = Array.from(document.querySelectorAll(`input[name="${FIELD}"]`))
    .find((e) => CERT_RE.test(e.value || ""));
  return el ? el.value : null;
}

// Real visitors only — never previews, demo links or sample pages.
export const trustedFormOn = ({ preview, demo, vertical }) => !(preview || demo || vertical?.isSamplePage);

// The SDK only attaches to a form that is already on the page, so it loads from the form itself.
export function useTrustedFormScript(ref, enabled) {
  useEffect(() => {
    if (!enabled || !ref.current) return;
    const here = window.location.pathname + window.location.search;
    if (sdkLoadedAt) {
      // A landing page reached in-app would reuse the old certificate — reload for a fresh one.
      if (sdkLoadedAt !== here) window.location.reload();
      return;
    }
    sdkLoadedAt = here;
    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    s.type = "text/javascript";
    s.async = true;
    // Same parameters as the account snippet from ActiveProspect's Setup page.
    s.src = `https://api.trustedform.com/trustedform.js?field=${FIELD}&use_tagged_consent=true&l=${Date.now()}${Math.random()}`;
    document.body.appendChild(s);
  }, [ref, enabled]);
}

// Wraps a multi-step funnel in one real form (the TrustedForm "offer").
export function TrustedFormOffer({ enabled, children }) {
  const ref = useRef(null);
  useTrustedFormScript(ref, enabled);
  return (
    <form ref={ref} noValidate onSubmit={(e) => e.preventDefault()} data-tf-element-role="offer" data-testid="tf-offer-form">
      {children}
    </form>
  );
}

// Consent text with the advertiser (firm, else platform brand) tagged for TrustedForm Verify.
export function ConsentText({ text, advertiser }) {
  const lower = text.toLowerCase();
  const name = [advertiser, PLATFORM_BRAND].find((n) => n && lower.includes(n.toLowerCase()));
  if (!name) return text;
  const at = lower.indexOf(name.toLowerCase());
  return (
    <>
      {text.slice(0, at)}
      <span data-tf-element-role="consent-advertiser-name">{text.slice(at, at + name.length)}</span>
      {text.slice(at + name.length)}
    </>
  );
}
